<script lang="ts">
	import { isFilled } from '@prismicio/client';
	import { asText } from '@prismicio/client/richtext';
	import { PrismicImage, PrismicLink, PrismicRichText } from '@prismicio/svelte';

	const { page } = $props();

	const image = isFilled.image(page.image)
		? page.image
		: isFilled.image(page.link.data.image)
			? page.link.data.image
			: false;
	const title = isFilled.richText(page.title)
		? page.title
		: isFilled.richText(page.link.data.title)
			? page.link.data.title
			: false;
	const description = isFilled.richText(page.description) ? page.description : false;
</script>

<article class="page-list-card">
	<PrismicLink field={page.link} class="page-list-card__link" title={asText(title)} />

	<div class="page-list-card__background">
		{#if image}
			<PrismicImage field={image} class="page-list-card__background--image" loading="lazy" />
		{/if}
	</div>

	<div class="page-list-card__content">
		<div class="row g-0 h-100 align-items-end">
			<div class="col-12 col-hd-9">
				{#if title}
					<h3 class="page-list-card__content--title">{asText(title)}</h3>
				{/if}

				{#if description}
					<div class="page-list-card__content--description">
						<PrismicRichText field={description} />
					</div>
				{/if}
			</div>
		</div>
	</div>
</article>
